// src/routes/invoicingRoutes.tsx
import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Lazy Invoicing pages
const InvoicesPage = lazy(() => import('../modules/invoicing/InvoicesPage'));
const PaymentsPage = lazy(() => import('../modules/invoicing/PaymentsPage'));
const CreditNotesPage = lazy(() => import('../modules/invoicing/CreditNotesPage'));

const Fallback = <div style={{ padding: 16 }}>Loading Invoicing…</div>;

const withSuspense = (el: JSX.Element) => <Suspense fallback={Fallback}>{el}</Suspense>;

export function renderInvoicingRoutes(
  Protected: ({ children }: { children: JSX.Element }) => JSX.Element
): JSX.Element {
  return (
    <>
      <Route path="/invoicing/invoices" element={withSuspense(<Protected><InvoicesPage /></Protected>)} />
      <Route path="/invoicing/payments" element={withSuspense(<Protected><PaymentsPage /></Protected>)} />
      <Route path="/invoicing/credit-notes" element={withSuspense(<Protected><CreditNotesPage /></Protected>)} />
    </>
  );
}

